import SearchParamsBase from '../../../Elements/SearchParamsBase';
import OfficeHelper from '../../../Helpers/ModelHelpers/OfficeHelper';

export default class TpRevenueByRevenuePeriodSearchParams extends SearchParamsBase {
  static saveType = 'TpRevenueByRevenuePeriodSearchParams';
  initialize() {
    this.RevenuePeriod = TpRevenueByRevenuePeriodSearchParams.GetCurrentRevenuePeriod();
    this.SelectedOffices = [];
  }

  static GetCurrentRevenuePeriod() {
    // Return yyyyMM format for the current month
    return parseInt(new Date().getFullYear().toString() + `0${new Date().getMonth() + 1}`.slice(-2), 10);
  }
}
